import type { ReactNode } from 'react';
import { clsx } from 'clsx';

export type PillTone =
  | 'upcoming'
  | 'due'
  | 'missed'
  | 'paid'
  | 'neutral'
  | 'warning'
  | 'error';

const tones: Record<PillTone, string> = {
  upcoming: 'bg-upcoming-background text-upcoming-text',
  due: 'bg-warning-background text-warning-text',
  missed: 'bg-error-background text-error-text-dark',
  paid: 'bg-notice-background text-notice-text',
  neutral: 'bg-pill-background text-pill-text',
  warning: 'bg-warning-background text-warning-text',
  error: 'bg-error-background text-error-text',
};

/**
 * The coloured label used for schedule status in both the register ("Upcoming",
 * "Due", "Missed") and the Schedules table.
 */
export function Pill({
  tone = 'neutral',
  icon,
  children,
  className,
}: {
  tone?: PillTone;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-sm font-medium',
        tones[tone],
        className,
      )}
    >
      {icon}
      {children}
    </span>
  );
}
